<style scoped>

	button {
		width: 120px;
	}

</style>

<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="section">
        <strong>Termos e Condições de Uso</strong>
      </div>
    </div>

    <div class="ui divider"></div>

    <div class="ui segment">

      <ol>

				<li><b>FUNCIONALIDADES</b>
					<br/><br/>
					<font style="text-decoration: underline;">EMPRESAS QUE AINDA NÃO SÃO CLIENTES DA COBRECOM</font>
					<br/>
					<div style="margin-left: 40px;">
						<ul>
							<li>Consulta e manifestação de interesse de compra dos produtos do estoque de oportunidades.</li>
						</ul>
					</div>
					<br/>
					<font style="text-decoration: underline;">EMPRESAS QUE JÁ SÃO CLIENTES DA COBRECOM</font>
					<br/>
					<div style="margin-left: 40px;">
						<ul>
							<li>Consulta e reserva de produtos do estoque de oportunidades.</li>
						</ul>
					</div>
					<br/>
					<font style="text-decoration: underline;">REPRESENTANTES</font>
					<br/>
					<div style="margin-left: 40px;">
						<ul>
							<li>Consulta e reserva de produtos do estoque de oportunidades;</li>
							<li>Inclusão de orçamentos;</li>
							<li>Acompanhamento do status dos orçamentos.</li>
							<li>Obtenção de segunda via de boletos.</li>
						</ul>
					</div>
				</li>

				<br/>

				<li><b>ESTOQUE DE OPORTUNIDADES</b>
					<ol style="list-style-type: lower-latin;">
						<li>O estoque de oportunidades é composto de produtos escolhidos pela Cobrecom, com objetivo de consulta,
							reserva ou venda para clientes ou futuros clientes;</li>
						<li>Os produtos devem ser reservados e vendidos conforme são exibidos e não podem ser fracionados;</li>
						<li>O objetivo é possibilitar um atendimento rápido ao cliente. Pois, o produto adquirido não necessita
							ser produzido ou processado.</li>
					</ol>
				</li>

				<br/>

				<li><b>RESERVAS DE ESTOQUE</b>
					<ol style="list-style-type: lower-latin;">
						<li>As reservas de estoque que não estão vinculadas a orçamentos terão um prazo de validade, e serão
							canceladas após este prazo expirar;</li>
						<li>O prazo das reservas de estoque realizadas fora do horário comercial, em finais de semana ou
							feriados, será contado a partir do próximo dia útil;</li>
						<li>As reservas de estoque vinculadas a orçamentos somente serão canceladas se os orçamentos forem cancelados;</li>
						<li>Como o estoque está disponível para consulta e reserva por diversos usuários, a reserva será
							concretizada para aquele que primeiramente concluir o processo.</li>
					</ol>
				</li>

				<br/>

				<li><b>PRAZOS DE ENTREGA</b>
					<ol style="list-style-type: lower-latin;">
						<li>Os prazos de entrega dos produtos do estoque de oportunidades estão sujeitos à aprovação de crédito
							e à logística de entrega.</li>
					</ol>
				</li>

				<br/>

				<li><b>DIVERGÊNCIAS DE ESTOQUE</b>
					<ol style="list-style-type: lower-latin;">
						<li>Eventuais divergências de estoque são possíveis devido ao armazenamento e manuseio dos produtos;</li>
						<li>Em caso de divergência, a Cobrecom entrará em contato comunicando e oferecendo alternativas.</li>
					</ol>
				</li>

				<br/>

				<li><b>DISPONIBILIDADE DO PORTAL</b>
					<ol style="list-style-type: lower-latin;">
						<li>O Portal Cobrecom estará disponível para uso 24h, exceto quando ocorrer necessidade de interrupção
							para manutenções ou atualizações do sistema.</li>
					</ol>
				</li>

				<br/>

				<li><b>CONFIDENCIALIDADE E SEGURANÇA</b>
					<ol style="list-style-type: lower-latin;">
						<li>A Cobrecom se compromete em utilizar as informações fornecidas somente para uso interno, e com
							objetivo exclusivo de desenvolvimento do relacionamento comercial entre as partes;</li>
						<li>O usuário é responsável por não divulgar seus dados de acesso, assegurando a confidencialidade
							e segurança das suas operações no Portal Cobrecom;</li>
						<li>O cliente ou futuro cliente aceitam receber comunicações da Cobrecom.</li>
					</ol>
				</li>

				<br/>

				<li><b>DÚVIDAS E ATUALIZAÇÕES</b>
					<ol style="list-style-type: lower-latin;">
						<li>Esclarecimentos de dúvidas e suporte poderão ser solicitados ao SAC, fone: 0800-7023163
							ou e-mail: <a href="mailto:sac@cobrecom.com.br">sac@cobrecom.com.br</a> (dias úteis em horário comercial);</li>
						<li>Atualizações nos Termos de Uso do Portal Cobrecom, poderão ser consultadas em <a id="useTermsLink" href="">aqui</a></li>
					</ol>
				</li>

				<br/>	
							
							<li><b>TREINAMENTOS</b>		
								<div style="margin-top: 5px;">A senha para acessar os vídeos é: <strong>ifcPortal</strong></div>														
								<ol style="list-style-type: lower-latin; margin-top: 5px;">
									<li><a class="clickable" @click="openNewTab('https://vimeo.com/215251118')">Acessar o Portal Cobrecom</a></li>
									<li><a class="clickable" @click="openNewTab('https://vimeo.com/215251144')">Termos e Condições de Uso</a></li>
									<li><a class="clickable" @click="openNewTab('https://vimeo.com/215251163')">Tela Principal</a></li>
									<li><a class="clickable" @click="openNewTab('https://vimeo.com/215251177')">Consultar e Reservar Estoque</a></li>
									<li><a class="clickable" @click="openNewTab('https://vimeo.com/215251184')"> Gerenciar Reservas de Estoque</a></li>
									<li><a class="clickable" @click="openNewTab('https://vimeo.com/215251201')">Incluir Orçamento de Estoque</a></li>
									<li><a class="clickable" @click="openNewTab('https://vimeo.com/215251228')">Incluir Orçamento de Fabricação</a></li>
									<li><a class="clickable" @click="openNewTab('https://vimeo.com/215251262')">Painel de Preços</a></li>
									<li><a class="clickable" @click="openNewTab('https://vimeo.com/215251293')">Mensagens</a></li>
									<li><a class="clickable" @click="openNewTab('https://vimeo.com/215251310')">Notificações</a></li>
									<li><a class="clickable" @click="openNewTab('https://vimeo.com/215251319')">Perfil do Usuário</a></li>					
								</ol>								
								<div style="margin-top: 15px;">
									Após o treinamento favor já utilizar o portal para envio de orçamentos x pedidos.
								</div>
							</li>
							
							<br/>		
							
							<li><b>DOWNLOADS</b>														
								<ol style="list-style-type: lower-latin;">
									<li><a href="/downloads/guia-de-estilo.pdf" download>Guia de Estilo</a></li>
									<li><a href="/downloads/logotipos.zip" download>Logotipos da COBRECOM</a></li>
									<li><a href="#" download>Manual do Representante</a></li>
									<li><a href="/downloads/formulario-verba-cooperada.pdf" download>Formulários de Verba Cooperada</a></li>
									<li><a href="/downloads/formulario-solicitacao-materiais.pdf" download>Formulário de Solicitação de Material Impresso</a></li>	
								</ol>																
							</li>

							<br/>
							<li><b>MANUAIS</b>														
								<ol style="list-style-type: lower-latin;">
									<li><a href="/downloads/manual_boleto.pdf" download>Emissão de Boletos</a></li>	
								</ol>																
							</li>
			</ol>

			<div style="margin-top: 30px;">
				Pedimos a gentileza de a partir de agora usar somente o Portal para cadastrar 
				Pedidos / Orçamentos / Realizar Reservas / Consultas de Pedidos – Clientes - Faturamentos.
			</div>

			<div style="margin-top: 20px;">
				Acesso em contingência*: 
				<a href="https://bkp.portalcobrecom.com.br:8443">https://bkp.portalcobrecom.com.br:8443</a>
			</div>

			<div style="margin-top: 10px; margin-bottom: 20px; text-decoration: underline; font-style: italic;">
				(*) Este acesso somente deve ser utilizado em casos de problemas com o acesso oficial!
			</div>

    </div>

    <button class="ui basic red button m-r-10" @click="onReject()">
      <i class="ban icon"></i> Rejeitar
    </button>
    <button class="ui blue button" :class="{ loading }" @click="onAccept()">
      <i class="check icon"></i> Aceitar
    </button>

		<div id="reject-dialog" class="ui tiny modal">
      <div class="ui header">
        Rejeição dos Termos de Uso
      </div>
      <div class="content">
        <p class="grey text">Ao rejeitar os Termos de Uso você não poderá utilizar o Portal Cobrecom</p>
      </div>
      <div class="actions">
        <button class="ui cancel basic button">
          <i class="remove icon"></i>
          Cancelar
        </button>
        <button class="ui red basic button" :class="{ loading }" @click="onConfirmRejection()">
          <i class="ban icon"></i>
          Rejeitar
        </button>
      </div>
    </div>

  </div>

</template>

<script>
	
	import { AppLocalStorage, AuthService, UserService } from "@/services"
	import AppBrowser from "@/utils/browser"

  export default {

		data() {
			return {
				loading: false,
			}
		},
    
    methods: {

			openNewTab(url) {
				AppBrowser.openNewTab(url)
			},

      onReject() {

				$("#reject-dialog").modal("show")
      },

      async onConfirmRejection() {
				
				this.loading = true

				try {

					await UserService.acceptUseTerms(this.$store.state.user.id, false)
					await AuthService.logout()

					AppLocalStorage.clear()

          location.reload()
					
				} catch (error) {
					
					this.loading = false
					this.$errorHandler(error)
				}
      },

      async onAccept() {

				this.loading = true

				try {

					await UserService.acceptUseTerms(this.$store.state.user.id, true)

					const user = await UserService.getById(this.$store.state.user.id)

					AppLocalStorage.set("user", user, "setUser")
					
					let route = "/"

					if (this.$isCustomerOrProspect())
						route = "products/search"

					this.$router.push(route)
					
				} catch (error) {
					
					this.loading = false
					this.$errorHandler(error)
				}
			},
    },
  }

</script>
